import React, {useState, useRef, useEffect} from 'react';
import {getIntersectionObserverInstance} from '@stencil/intersection-observer';

const Image = (props: {
  src: string;
  alt?: string;
  fallback?: string;
  className?: string;
  itemProp?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}) => {
  const sourceRef = useRef();
  const [error, setOnError] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const {
    src,
    alt = '',
    fallback = '',
    className,
    itemProp = '',
    onClick = () => {},
    style = {},
  } = props;

  const imagePlaceholder =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  };

  let observer = null;
  const IntersectionObserver = getIntersectionObserverInstance();

  useEffect(() => {
    if (IntersectionObserver) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          // if element is intersecting as per threshold set, then update state and remove observer
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(entry.target);
          }
        });
      }, options);
    }

    if (observer) observer.observe(sourceRef.current);

    return () => {
      if (observer && observer.current) observer.current.disconnect();
    };
  }, []);

  if (error) return <img ref={sourceRef} {...props} src={fallback} alt={alt} />;

  return (
    <img
      ref={sourceRef}
      src={IntersectionObserver ? (isVisible ? src : imagePlaceholder) : src}
      alt={alt}
      className={className}
      // data-src={src}
      onError={() => {
        setOnError(true);
      }}
      data-testid={props['data-testid'] || ''}
      style={{...style}}
      onClick={onClick}
      itemProp={itemProp}
    />
  );
};

export default Image;
